import {FavouritesGeneralCallbackContractModel} from "@next/eventservice"
import env from "../../config/env"
import {FavouriteState} from "../../models/Favourites"

export const getFavouriteIconPath = (icon: string, state: FavouriteState | null, realm: string): string => {
    return `${env.REACT_APP_BLOB_STORAGE_PATH.replace(/\/$/, "")}/icons/shared/brand/${realm}/${icon}${
        state ? `#${state}` : ``
    }`
}

export const isFavouriteProduct = (data: any, productId: string): boolean => {
    const getFavouriteIds: string[] = data?.map(item => item?.ItemNumber?.replace(/-/g, "")) || []

    return getFavouriteIds?.includes(productId) || false
}

export const setFavoritesCallback = (
    favouritesCallBackData: FavouritesGeneralCallbackContractModel,
    setFavouritedColourways: (...args: any[]) => void,
) => {
    if (favouritesCallBackData.success) {
        if (favouritesCallBackData.data?.ShoppingListItems)
            setFavouritedColourways(
                shoppingListItemsToFavouritedColourways(favouritesCallBackData.data?.ShoppingListItems),
            )
    }
}

export const getNextFavouritesData = () => {
    return window.NextFavourites?.Data
}

export const shoppingListItemsToFavouritedColourways = (shoppingListItems: any[]) =>
    shoppingListItems.map(shoppingListItem => shoppingListItem?.ItemNumber.replace(/-/g, ""))
